// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ─────────────────────────────────────────────────────────────────────────────

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          background: 'linear-gradient(145deg, #EEF2FF 0%, #F2F2F7 45%, #F0F4FF 100%)',
          backgroundAttachment: 'fixed',
          minHeight: '100vh',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        '::selection': {
          backgroundColor: 'rgba(0,122,255,0.15)',
          color: '#1C1C1E',
        },
        '::-moz-selection': {
          backgroundColor: 'rgba(0,122,255,0.15)',
          color: '#1C1C1E',
        },
        'scrollbar-width': 'thin',
        '::-webkit-scrollbar': {
          width: 4,
          height: 4,
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.2)',
          borderRadius: 2,
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.3)',
          },
        },
      }}
    />
  );

  return inputGlobalStyles;
}
